export const eeiiTabsStyles = (theme) => ({
  tabSelected: {
    backgroundColor: theme.palette.grey[100],
  },
})
